<!-- فرم مدیریت اشخاص -->
<!-- طرف حساب ها -->
<template>
    <div class="row">
        <div class="col-12 p-0">
            <div class="row p-0 d-flex justify-content-between align-items-center">
                <div class="col-4 p-0 pb-2">
                    <div class="input-group p-0">
                        <input
                        id="tarafHesabTextDocInfoSearch"
                        placeholder="جستجو پیشرفته در لیست اشخاص (Enter)"
                        type="text"
                        class="form-control form-control-sm rounded-0"
                        v-on:focus="$event.target.select()"
                        v-on:keyup.enter="searchData($event.target.value)"
                        />
                        <div class="input-group-prepend rounded-0">
                        <span
                            class="
                            input-group-text input-group-box-size
                            bg-secondary
                            rounded-left
                            white-text
                            "
                        >
                            <a v-on:click="searchData('Search')">
                            <i class="fas fa-search"></i>
                            </a>
                        </span>
                        </div>
                    </div>
                </div>                
                <div class="col-4 p-0 pb-2 d-flex justify-content-end align-items-center">
                    <a
                        class="btn btn-secondary btn-sm btn-floating p-0 m-0 mb-2 d-flex justify-content-around align-items-center"
                        style="width: 110px; height: 30px;"
                        title="ایجاد شخص جدید"
                        data-toggle="modal" 
                        data-target="#ModalAddNewPerson"
                        v-on:click="isShowAddNewPerson = true"
                    >
                        شخص جدید
                        <i class="fas fa-user-plus fa-1x-half text-white"></i>
                    </a>

                </div>

            </div>
        </div>
        <div class="table-responsive">
            <table
                class="
                table table-bordered table-sm
                text-center
                table-font-size
                "
            >
                <thead style="background-color: #f7f7f7">
                    <td colspan="14" class="position-relative">
                        تعداد سطرهای گزارش : {{ this.ListTbPersonFilterData.length }} مورد
                        <!-- انتقال به سطر انتهایی -->
                        <a
                        v-on:click="scrollTable('LastRow')"
                        title="مشاهده سطر انتهایی"
                        class="position-absolute"
                        style="top: 24%; right: 7px"
                        >
                        <i
                            class="far fa-arrow-alt-circle-down fa-1x-half text-secondary"
                        ></i>
                        </a>
                    </td>
                </thead>
                <!-- سربرگ جدول -->
                <thead class="text-light bg-secondary">
                    <td style="max-width: 50px;">ردیف</td>
                    <td>شناسه</td>
                    <td>شماره ملی</td>
                    <td>کد اقتصادی</td>
                    <td>نام</td>
                    <td>نام خانوادگی</td>
                    <td>نام پدر</td>
                    <td>تلفن</td>
                    <td>همراه</td>
                    <td>کد پستی</td>
                    <td>نشانی</td>
                    <td>شغل</td>
                    <td>نام فروشگاه</td>
                    <!-- <td>فکس</td>
                    <td>شماره حساب</td>
                    <td>شماره کارت</td>
                    <td>شماره شبا</td> -->
                    <td>مدیریت</td>
                </thead>
                <!-- بدنه جدول -->
                <tbody>
                    <template v-for="row in getTbPersonDataPaging(intPageNumber, intCountRow)">
                        <tr
                            :key="row.NPerID"
                            :class="{ selRow: SelectRowID == row.RowIndex }"
                            v-on:click="SaveRowSelect(row.RowIndex)"
                            v-bind:id="row.NPerID"
                            style="cursor: pointer;"
                        >
                            <!-- ردیف -->
                            <td
                            style="
                                max-width: 50px;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                            "
                            >
                            {{ row.RowIndex }}
                            </td>
                            <!-- کد کاربر -->
                            <td
                            style="
                                max-width: 120px;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                            "
                            >
                            {{ row.NPerID }}
                            </td>
                            <!-- شماره ملی -->
                            <td
                            style="
                                max-width: 120px;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                            "
                            >
                            {{ row.SPerNationalId }}
                            </td>
                            <!-- کد اقتصادی -->
                            <td
                            style="
                                max-width: 120px;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                            "
                            >
                            {{ row.NPerTaxNu }}
                            </td>
                            <!-- نام -->
                            <td
                            style="
                                max-width: 120px;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                            "
                            >
                            {{ row.NPerName }}
                            </td>
                            <!-- نام خانوادگی -->
                            <td
                            style="
                                max-width: 120px;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                            "
                            >
                            {{ row.NPerLastName }}
                            </td>
                            <!-- نام پدر -->
                            <td
                            style="
                                max-width: 120px;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                            "
                            >
                            {{ row.NPerFatherName }}
                            </td>
                            <!-- تلفن -->
                            <td
                            style="
                                max-width: 120px;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                            "
                            >
                            {{ row.NPerTelCode + ' ' + row.NPerTel }}
                            </td>
                            <!-- همراه -->
                            <td
                            style="
                                max-width: 120px;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                            "
                            >
                            {{ row.SMobileNu }}
                            </td>
                            <!-- کد پستی -->
                            <td
                            style="
                                text-align: right !important;
                                padding-right: 5px !important;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                                max-width: 250px;
                            "
                            >
                            {{ row.NPerPostcalCode }}
                            </td>
                            <!-- نشانی -->
                            <td
                            style="
                                max-width: 120px;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                            "
                            >
                            {{ row.NPerAddress }}
                            </td>
                            <!-- شغل -->
                            <td
                            style="
                                max-width: 120px;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                            "
                            >
                            {{ row.SJob }}
                            </td>
                            <!-- نام فروشگاه -->
                            <td
                            style="
                                max-width: 120px;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                            "
                            >
                            {{ row.SShopName }}
                            </td>
                            <!-- فکس -->
                            <!-- <td
                            style="
                                max-width: 120px;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                            "
                            >
                            {{ row.SFaxNu }}
                            </td> -->
                            <!-- شماره حساب -->
                            <!-- <td
                            style="
                                max-width: 120px;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                            "
                            >
                            {{ row.SAccNu }}
                            </td> -->
                            <!-- شماره کارت -->
                            <!-- <td
                            style="
                                max-width: 120px;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                            "
                            >
                            {{ row.SAccCardNu }}
                            </td> -->
                            <!-- شماره شبا -->
                            <!-- <td
                            style="
                                max-width: 120px;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                            "
                            >
                            {{ row.SAccIRNu }}
                            </td> -->
                            <!-- مدیریت -->
                            <td
                            style="
                                max-width: 120px;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                                padding-left: 5px !important;
                                padding-right: 5px !important;
                            "
                            >
                                <!-- منوی ویرایش پروفایل کاربری -->
                                <a 
                                    href="#" 
                                    title="ویرایش"
                                    v-on:click="CallEditPerson(row.NPerID)"
                                    data-toggle="modal" 
                                    data-target="#ModalEditPerson"
                                >
                                    <!-- <i class="far fa-eye fa-lg m-1 text-primary"></i> -->
                                    <i class="fas fa-user-edit fa-lg m-1 text-primary"></i>
                                </a>
                                <!-- منوی حذف کاربر -->
                                <a 
                                    href="#" 
                                    title="حذف کاربر"
                                    v-on:click="CallDeleteUser(row.NPerID, (row.NPerName + ' ' + row.NPerLastName + ' - ' + row.SPerNationalId).trim())"
                                >
                                    <i class="fas fa-user-alt-slash fa-lg m-1 pink-text"></i>
                                </a>
                            </td>
                        </tr>
                    </template>
                </tbody>
                <!-- پابرگ جدول -->
                <tfoot style="background-color: #f7f7f7" id="LastRow">
                    <td class="">
                        <!-- انتقال به سطر ابتدایی -->
                        <a
                        v-on:click="scrollTable('tarafHesabTextDocInfoSearch')"
                        title="مشاهده سطر ابتدایی"
                        >
                        <i class="far fa-arrow-alt-circle-up fa-1x-half text-secondary"></i>
                        </a>
                    </td>
                    <td colspan="13">
                        <nav aria-label="..." v-if="getCountPage() > 1">
                            <ul class="pagination flex-wrap m-0 p-0 px-1 d-flex justify-content-center align-items-center">
                                <template v-for="(row, index) in getCountPage()">
                                    <li 
                                        :key="index"
                                        class="page-item d-flex justify-content-center align-items-center" 
                                        :class="{active: intPageNumber == (index + 1)}"
                                        aria-current="page" 
                                        style="min-width: 35px; max-width: 35px; text-align: center;"
                                    >
                                        <span class="page-link" v-if="intPageNumber == (index + 1)">{{index + 1}}</span>
                                        <a class="page-link" v-on:click="intPageNumber = (index + 1)" v-else>{{index + 1}}</a>
                                    </li>
                                </template>
                                <!-- تعیین تعداد رکورد در هر صفحه -->
                                <li class="page-item d-flex align-items-center mr-2" style="max-width: 65px;">
                                    <select class="form-control form-control-sm rounded-3" v-model="intCountRow">
                                        <option value="100">100</option>
                                        <option value="200">200</option>
                                        <option value="500">500</option>
                                        <option value="1000">1000</option>
                                    </select>
                                </li>
                            </ul>
                        </nav>
                    </td>
                </tfoot>
            </table>
        </div>
        
        <!-- مودال ثبت شخص جدید -->
        <add-new-person
            v-if="isShowAddNewPerson"
            v-on:AddNewPerson="HideModalAddNewPerson"
        ></add-new-person>
        <!-- پایان مودال ثبت کاربر جدید -->

        <!-- مودال ویرایش حساب کاربری -->
        <edit-person
            v-if="isShowEditPerson"
            v-bind:PersonValue="PersonDataForEdit"
            v-on:EditPerson="HideModalEditPerson"
        ></edit-person>
        <!-- پایان مودال ویرایش حساب کاربری -->

    </div>
</template>

<script>
import EditPerson from "./Components/EditPerson.vue"
import AddNewPerson from "./Components/AddNewPerson.vue"

export default {
    components: {
        EditPerson: EditPerson,
        AddNewPerson: AddNewPerson,
    },
    data() {
        return {
            // آیدی سطر کلیک شده
            SelectRowID: 1,
            // لیست محلی اشخاص
            ListTbPersonMasterData: [],
            // لیست محلی فیلتر شده بر اثر جستجو
            ListTbPersonFilterData: [],
            // فیلد نگهداری نام آخرین فیلد مرتب سازی شده
            lastSortFieldName: '',
            // آدرس تصویر لطفا صبر کنید
            waitImage: this.$store.getters.getImageUrl + "wait.gif",
            // کنترل نمایش ویرایش اطلاعات پروفایل
            isShowEditPerson: false,
            // اطلاعات شخصیت جهت ویرایش
            PersonDataForEdit: {},
            // کنترل تعریف شخصیت جدید
            isShowAddNewPerson: false,
            // شماره صفحه
            intPageNumber: 1,
            // تعداد سطرها در هر صفحه
            intCountRow: 200
        }
    },
    created(){
        this.getTbPersonData();
    },
    methods: { 
        // جابجایی به سطر جمع یا سربرگ
        scrollTable(objectID) {
            console.log(objectID);
            $("#" + objectID).scrollintoview({
                duration: 500,
            });
        },
        
        // دریافت اطلاعات لیست اشخاص از مخزن 
        getTbPersonData() {
            // دریافت لیست اشخاص از مخزن محلی و نگهداری در مخزن اصلی فرم
            // فقط اشخاص حقیقی و حقوقی منتقل می شوند
            this.ListTbPersonMasterData = this.$store.getters.getTbPersonData(0);
            // انتقال مخزن اصلی فرم به مخزن مخصوص فیلتر
            this.ListTbPersonFilterData = this.ListTbPersonMasterData;
            // درج شماره ردیف برای سطرها
            this.callSortRowIndex();
        },

        // رویداد ویرایش حساب کاربری
        async CallEditPerson(NPerID){
            // جستجو در مخزن اصلی فرم و استخراج اطلاعات شخصیت مورد نظر
            let index = this.ListTbPersonFilterData.findIndex(itme => itme.NPerID == NPerID)
            if(index != -1){
                // ارسال اطلاعات شخصیت به مودال ویرایش اطلاعات
                this.PersonDataForEdit = await this.ListTbPersonFilterData[index];
            }
            // فراخوانی کامپاننت ویرایش اطلاعات
            this.isShowEditPerson = true;
        },

        // رویداد حذف کاربر
        async CallDeleteUser(NPerID, SUserName){
            swal({
                title: "تقاضای حذف طرف حساب",
                text: "شما تقاضا حذف طرف حساب به شماره " +
                        NPerID + " ( " + SUserName + " ) " +
                        " را کرده‌اید ! آیا ادامه می دهید؟",
                icon: "warning", // success, warning, error, info
                buttons: {
                    cancel: "انصراف",
                    ok: "بله طرف حساب حذف شود",
                },
            }).then(async (value) => {
                if (value) {
                    // نمایش لطفا صبر نمایید
                    this.$store.dispatch("pleaseWait", {
                    notText: "حذف طرف حساب از سرور",
                    });
                    let token = await this.$store.getters.getUserData.token;
                    var userData = await this.$store.dispatch("DeletePersonDataFromServer", {NPerID, token});
                    if(userData){
                        this.getTbPersonData();
                        // this.getTbPersonDataPaging(intPageNumber, intCountRow);
                    }
                    // لغو نمایش لطفا صبر نمایید
                    this.$store.dispatch("pleaseWait", {
                    stop: true,
                    });
                }
            });
        },

        // رویداد بسته شدن مودال ویرایش حساب کاربری
        async HideModalEditPerson(value){
            // مخفی کردن مودال ویرایش اطلاعات شخصیت
            this.isShowEditPerson = false;
            if(value != null){
                // اعمال تغییرات در مخزن محلی فرم
                let index = this.ListTbPersonFilterData.findIndex(itme => itme.NPerID == value.NPerID)
                if(index != -1){
                    // ذخیره تغییرات در مخزن محلی
                    this.ListTbPersonFilterData[index] = value;
                } else {
                    alert('Not Find Filter');
                }
            }
        },

        // رویداد بسته شدن مودال ثبت شخصیت جدید
        async HideModalAddNewPerson(value){
            // مخفی کردن مودال ثبت شخصیت جدید
            this.isShowAddNewPerson = false;
            // دریافت مجدد لیست اشخاص از مخزن محلی
            this.getTbPersonData();
        },

        // نمایش اطلاعات اشخاص با قابلیت صفحه بندی
        getTbPersonDataPaging(pageNumber, countRow){
            // بررسی اعتبار شماره صفحه
            if (parseInt(pageNumber) > this.getCountPage()){
                pageNumber = 1;
                this.intPageNumber = 1;
            }
            // لیست محلی اشخاص
            let ListTbPersonDataPaging = [];
            // شماره شروع رکورد
            let startRowIndex = pageNumber == 1 ? 1 : (parseInt(countRow) * (parseInt(pageNumber) -1) + 1);
            // انتخاب رکوردهای صفحه مورد نظر
            ListTbPersonDataPaging = this.ListTbPersonFilterData.filter(function(item){
                return (item.RowIndex >= startRowIndex && item.RowIndex < (parseInt(startRowIndex) + parseInt(countRow)))
            });
            return ListTbPersonDataPaging;
        },
        
        // دریافت تعداد صفحات لیست اشخاص
        getCountPage(){
            if(this.ListTbPersonFilterData != null && this.ListTbPersonFilterData.length > 0){
                let intCountPage = this.ListTbPersonFilterData.length;
                intCountPage = intCountPage / this.intCountRow;
                if(this.ListTbPersonFilterData.length % this.intCountRow){
                    intCountPage ++;
                }
                return parseInt(intCountPage);
            } else {
                return 1;
            }
        },

        // نگهداری اطلاعات سطر انتخاب شده
        SaveRowSelect(RowIndex) {
            this.SelectRowID = RowIndex;
        },

        // جستجو/فیلتر در لیست اسناد
        searchData(searchValue) {
            // ریست شماره صفحه
            this.intPageNumber = 1;
            //
            if (searchValue === "Search") {
                searchValue =
                $("#tarafHesabTextDocInfoSearch").val() != ""
                    ? $("#tarafHesabTextDocInfoSearch").val()
                    : "";
            }
            if (searchValue != "") {
                this.ListTbPersonFilterData = this.ListTbPersonMasterData.filter(function(item){
                    return (item.NPerID.toString().startsWith(searchValue) ||
                        item.SPerNationalId.toString().startsWith(searchValue) ||
                        item.NPerTaxNu.toString().startsWith(searchValue) ||
                        item.NPerName.toString().includes(searchValue) ||
                        item.NPerLastName.toString().includes(searchValue) ||
                        item.SShopName.toString().includes(searchValue) ||
                        item.SMobileNu.toString().startsWith(searchValue) ||
                        item.SFaxNu.toString().startsWith(searchValue) ||
                        item.SAccNu.toString().startsWith(searchValue) ||
                        item.SAccCardNu.toString().startsWith(searchValue) ||
                        item.SAccIRNu.toString().startsWith(searchValue) ||
                        item.NAccBank.toString().includes(searchValue) ||
                        item.NPerFatherName.toString().includes(searchValue))
                });
                if(this.ListTbPersonFilterData.length > 0){
                    // انتخاب اولین سطر پیدا شده
                    this.SaveRowSelect(this.ListTbPersonFilterData[0].RowIndex);
                    // اصلاح شماره ردیف ها
                    // this.callSortRowIndex();
                } else {
                    this.SelectRowID = 1;
                }
            } else {
                this.ListTbPersonFilterData = this.ListTbPersonMasterData;
                // اصلاح شماره ردیف ها
                // this.callSortRowIndex();
            }
        },

        // مرتب سازی شماره ردیف ها
        callSortRowIndex(){
            if(this.ListTbPersonFilterData.length > 0){
                // اصلاح شماره ردیف ها
                for (var i = 0 ; i < this.ListTbPersonFilterData.length; i++){
                    this.ListTbPersonFilterData[i].RowIndex = i + 1;
                }
            }
        },

        // مرتب سازی لیست بر اساس فیلد انتخابی
        sortDocRow: function (sortFieldName, sortFieldType) {
            // منبع مطلب
            // https://www.codegrepper.com/code-examples/javascript/frameworks/vue/Sort+numbers+in+javascript
            let docrow = this.ListTbDocInfo;
            // بررسی وضعیت مرتب سازی صعودی یا نزولی
            if(sortFieldType === ""){
                if(this.lastSortFieldName === sortFieldName){
                // فیلد تکراری است لذا مرتب سازی از بزرگ به کوچک
                sortFieldType = 'desc';
                // تخلیه نام آخرین فیلد مرتب سازی شده
                this.lastSortFieldName = '';
                } else {
                // فیلد جدید است لذا مرتب سازی از کوچک به بزرگ
                sortFieldType = 'asc';
                // نگهداری نام آخرین فیلد مرتب سازی شده
                this.lastSortFieldName = sortFieldName;
                }
            }
            
            // Set slice() to avoid to generate an infinite loop!
            // تکه تکه کردن() برای جلوگیری از تولید یک حلقه بی نهایت!
            if (docrow.length > 0) {
                if (sortFieldName === "NId") {
                    // شناسه سند
                    // مرتب سازی فیلد عددی
                    if(sortFieldType === 'asc')
                        this.ListTbDocInfo = docrow.sort((a, b) => a.NId - b.NId);
                    else
                        this.ListTbDocInfo = docrow.sort((a, b) => b.NId - a.NId);

                } if (sortFieldName === "NYear") {
                    // سال
                    // مرتب سازی فیلد عددی
                    if(sortFieldType === 'asc')
                        this.ListTbDocInfo = docrow.sort((a, b) => a.NYear - b.NYear);
                    else
                        this.ListTbDocInfo = docrow.sort((a, b) => b.NYear - a.NYear);

                } else if (sortFieldName === "NDocNu"){
                    // شماره سند
                    // مرتب سازی فیلد عددی
                    if(sortFieldType === 'asc')
                        this.ListTbDocInfo = docrow.sort((a, b) => a.NDocNu - b.NDocNu);
                    else
                        this.ListTbDocInfo = docrow.sort((a, b) => b.NDocNu - a.NDocNu);

                } else if (sortFieldName === "SDocDate") {
                    // تاریخ
                    // مرتب سازی فیلد متنی
                    this.ListTbDocInfo = docrow.sort((a,b) => {
                        let f1 = '', f2 = '';
                        if(sortFieldType === 'asc'){
                            f1 = a.SDocDate;
                            f2 = b.SDocDate;
                        } else {
                            f1 = b.SDocDate;
                            f2 = a.SDocDate;
                        }

                        if (f1 < f2) {
                            return -1
                        }
                        if (f1 > f2) {
                            return 1
                        }
                        return 0
                    });
                } else if (sortFieldName === "SDocType"){
                    // نوع سند
                    // مرتب سازی فیلد متنی
                    this.ListTbDocInfo = docrow.sort((a,b) => {
                        let f1 = '', f2 = '';
                        if(sortFieldType === 'asc'){
                            f1 = a.SDocType;
                            f2 = b.SDocType;
                        } else {
                            f1 = b.SDocType;
                            f2 = a.SDocType;
                        }

                        if (f1 < f2) {
                            return -1
                        }
                        if (f1 > f2) {
                            return 1
                        }
                        return 0
                    });
                } else if (sortFieldName === "SDocDesc") {
                    // شرح سند
                    // مرتب سازی فیلد متنی
                    this.ListTbDocInfo = docrow.sort((a,b) => {
                        let f1 = '', f2 = '';
                        if(sortFieldType === 'asc'){
                            f1 = a.SDocDesc;
                            f2 = b.SDocDesc;
                        } else {
                            f1 = b.SDocDesc;
                            f2 = a.SDocDesc;
                        }

                        if (f1 < f2) {
                            return -1
                        }
                        if (f1 > f2) {
                            return 1
                        }
                        return 0
                    });
                } else if (sortFieldName === "NDebit") {
                    // بدهکار
                    // مرتب سازی فیلد عددی
                    if(sortFieldType === 'asc')
                        this.ListTbDocInfo = docrow.sort((a, b) => a.NDebit - b.NDebit);
                    else
                        this.ListTbDocInfo = docrow.sort((a, b) => b.NDebit - a.NDebit);
                } else if (sortFieldName === "NCredit") {
                    // بستانکار
                    // مرتب سازی فیلد عددی
                    if(sortFieldType === 'asc')
                        this.ListTbDocInfo = docrow.sort((a, b) => a.NCredit - b.NCredit);
                    else
                        this.ListTbDocInfo = docrow.sort((a, b) => b.NCredit - a.NCredit);
                } else if (sortFieldName === "SStatus") {
                    // وضعیت سند
                    // مرتب سازی فیلد متنی
                    this.ListTbDocInfo = docrow.sort((a,b) => {
                        let f1 = '', f2 = '';
                        if(sortFieldType === 'asc'){
                            f1 = a.SStatus;
                            f2 = b.SStatus;
                        } else {
                            f1 = b.SStatus;
                            f2 = a.SStatus;
                        }

                        if (f1 < f2) {
                            return -1
                        }
                        if (f1 > f2) {
                            return 1
                        }
                        return 0
                    });
                } else if (sortFieldName === "SOrgCode") {
                    // سازمان
                    // مرتب سازی فیلد متنی
                    this.ListTbDocInfo = docrow.sort((a,b) => {
                        let f1 = '', f2 = '';
                        if(sortFieldType === 'asc'){
                            f1 = a.SOrgCode;
                            f2 = b.SOrgCode;
                        } else {
                            f1 = b.SOrgCode;
                            f2 = a.SOrgCode;
                        }

                        if (f1 < f2) {
                            return -1
                        }
                        if (f1 > f2) {
                            return 1
                        }
                        return 0
                    });
                }
            } else {
                return [];
            }
        },

    },

}
</script>

<style scoped>
.selRow {
  background-color: #fbff94;
}
.pagination .page-item .page-link:hover{
    background-color: #efff6e;
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/ListTarafHesabha/ListTarafHesabha.vue